import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./login.css";
import btnCancel from "./img-login/btn-cancel-login.svg";
import RoutesToPages from "../../assets/RoutesToPages/Routes";
import ServerRequest from "../../ServerRequests/ServerRequest";
import HandleLocalData from "../../modules/HandleLocalData";
import { ReactComponent as LoginLogo } from "./img-login/logo.svg";
import { ReactComponent as ErrorLoginLogo } from "./img-login/logo-red-eyes.svg";

const LoginPage = () => {
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef(null);
  const countryCodeRef = useRef(null);
  const logoRef = useRef(null);
  const pencilImgRef = useRef(null);
  const errorNumberRef = useRef(null);
  const [isNotCreatedUser, setIsNotCreatedUser] = useState(false);
  const navigate = useNavigate();
  const loginContainerRef = useRef(null);
  const timerFadeIn = useRef(null);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (loginContainerRef.current) {
      loginContainerRef.current.classList.add("login-fade-in");
    }

    timerFadeIn.current = setTimeout(() => {
      loginContainerRef.current.classList.remove("login-fade-in");
    }, 350);

    return () => {
      clearTimeout(timerFadeIn.current);
    };
  }, []);

  const handleKeyPress = (value) => {
    if (inputValue.length < 8) {
      const newValue = inputValue.replace(/\D/g, "") + value;
      setInputValue(newValue);
      hideError();
    }
  };

  const handleClear = () => {
    const newValue = inputValue.slice(0, inputValue.length - 1);
    hideError();
    setInputValue(newValue);
  };

  const applyMask = (value) => {
    const newValue = value.replace(/\D/g, ""); // Видаляємо всі нецифрові символи
    return `(${newValue.substring(0, 2)})-${newValue.substring(
      2,
      4
    )}-${newValue.substring(4, 6)}-${newValue.substring(6, 8)}`;
  };

  const redirectToMainPage = () => {
    navigate(RoutesToPages.mainPage);
  };

  const redirectToUserProfile = () => {
    navigate(RoutesToPages.userProfile);
  };

  // //for the test flow
  // /* ******************************************************************** */
  //
  // const handleCheckNumber = async () => {
  //   const phoneNumber = countryCodeRef.current.textContent.slice(1) +
  //     inputRef.current.value.replace(/\D/g, "");
  //
  //   console.log(phoneNumber)
  //
  //   if (inputRef.current && inputValue.length === 8) {
  //     if (inputRef.current && phoneNumber.length === 11) {
  //       switch (phoneNumber) {
  //         case '96800000000':
  //           console.log("000...")
  //           inputRef.current.classList.add('invalid-number-error');
  //           pencilImgRef.current.src = require('./img-login/edit-pencil-invalid.svg').default;
  //           errorNumberRef.current.innerHTML =
  //             `You do not have access to the service. Click
  //           <a class="sign-up-link" href="https://om.servicelands.com/trn/avocado/general/wsx/lp1_nbvgfd/wap/">here</a> to sign up.`;
  //           errorNumberRef.current.classList.add('show-error-number');
  //           setIsNotCreatedUser(true);
  //           setIsError(true);
  //           break;
  //
  //         case '96811111111':
  //           console.log("111...")
  //           redirectToUserProfile();
  //           sessionStorage.setItem('phoneNumber', phoneNumber);
  //           localStorage.setItem('phoneNumber', phoneNumber);
  //           break;
  //
  //         case '96833333333':
  //           console.log("333...")
  //           redirectToUserProfile();
  //           sessionStorage.setItem('phoneNumber', phoneNumber);
  //           localStorage.setItem('phoneNumber', phoneNumber);
  //           break;
  //
  //         default:
  //           let serverData = await ServerRequest.authenticateUserData(phoneNumber);
  //           let parsedServerData = await serverData.json();
  //
  //           console.log(serverData);
  //           console.log(parsedServerData)
  //
  //           if (parsedServerData.status === 201) {
  //             redirectToUserProfile();
  //             sessionStorage.setItem('phoneNumber', phoneNumber);
  // localStorage.setItem('phoneNumber', phoneNumber);
  //           }
  //
  //           if (parsedServerData.status === 200) {
  // localStorage.setItem('phoneNumber', phoneNumber);
  //             sessionStorage.setItem('phoneNumber', phoneNumber);
  //             const userHashFromDB = parsedServerData.userProfileData.userHash;
  //
  //             if (userHashFromDB) {
  //               localStorage.setItem('userHash', userHashFromDB);
  //               try {
  //                 HandleLocalData.prepareAndStoreUserData(parsedServerData);
  //               } catch (error) {
  //                 console.error('Error parsing:', error);
  //               }
  //               redirectToMainPage();
  //             }
  //           } else {
  //             checkServerErrorNumber(parsedServerData.status);
  //           }
  //       }
  //     }
  //   } else {
  //     console.log('else')
  //     checkError();
  //   }
  // };
  //
  // /* ******************************************************************** */

  const handleCheckNumber = async () => {
    const phoneNumber =
      countryCodeRef.current.textContent.slice(1) +
      inputRef.current.value.replace(/\D/g, "");

    if (inputRef.current && inputValue.length === 8) {
      if (inputRef.current && phoneNumber.length === 11) {
        let serverData = await ServerRequest.authenticateUserData(phoneNumber);
        let parsedServerData = await serverData.json();

        // console.log(serverData);
        // console.log(parsedServerData);

        if (parsedServerData.status === 201) {
          redirectToUserProfile();
          sessionStorage.setItem("phoneNumber", phoneNumber);
          localStorage.setItem("phoneNumber", phoneNumber);
        }

        if (parsedServerData.status === 200) {
          sessionStorage.setItem("phoneNumber", phoneNumber);
          localStorage.setItem("phoneNumber", phoneNumber);
          const userHashFromDB = parsedServerData.userProfileData.userHash;

          if (userHashFromDB) {
            localStorage.setItem("userHash", userHashFromDB);
            try {
              HandleLocalData.prepareAndStoreUserData(parsedServerData);
            } catch (error) {
              console.error("Error parsing:", error);
            }
            redirectToMainPage();
          }
        } else {
          checkServerErrorNumber(
            parsedServerData.status,
            parsedServerData.code
          );
        }
      }
    } else {
      checkError();
    }
  };

  const checkServerErrorNumber = (status, code) => {
    pencilImgRef.current.src =
      require("./img-login/edit-pencil-invalid.svg").default;

    if (code === 401) {
      inputRef.current.classList.add("invalid-number-error");
      errorNumberRef.current.innerHTML = `You do not have access to the service. Click
        <a class="sign-up-link" href="https://om.servicelands.com/trn/avocado/general/wsx/lp1_nbvgfd/wap/">here</a> to sign up.`;
      setIsNotCreatedUser(true);
    } else {
      inputRef.current.classList.add("invalid-number", "invalid-number-error");
      errorNumberRef.current.innerHTML = "Incorrect number";
    }

    errorNumberRef.current.classList.add("show-error-number");
    setIsError(true);
  };

  const checkError = () => {
    if (inputRef.current && inputValue.length > 0 && inputValue.length < 8) {
      pencilImgRef.current.src =
        require("./img-login/edit-pencil-invalid.svg").default;
      inputRef.current.classList.add("invalid-number", "invalid-number-error");
      errorNumberRef.current.innerHTML = "Incorrect number";
      errorNumberRef.current.classList.add("show-error-number");
      setIsError(true);
    } else {
      pencilImgRef.current.src =
        require("./img-login/edit-pencil-invalid.svg").default;
      inputRef.current.classList.add("invalid-number", "invalid-number-error");
      setIsError(true);
    }
  };

  const hideError = () => {
    inputRef.current.classList.remove("invalid-number", "invalid-number-error");
    setIsError(false);
    pencilImgRef.current.src = require("./img-login/edit-pencil.svg").default;
    errorNumberRef.current.classList.remove("show-error-number");
  };

  return (
    <div ref={loginContainerRef} className="login-container">
      {isError ? (
        <ErrorLoginLogo className="login-logo" />
      ) : (
        <LoginLogo className="login-logo" />
      )}
      <p className="login-title">Wanna get healthier?</p>
      <div className="login-form">
        <p className="login-form__title">
          Enter your phone number for authorization
        </p>
        <div className="keypad-container">
          <div className="input-login-container">
            <span ref={countryCodeRef} className="country-code">
              +968
            </span>
            <input
              type="tel"
              ref={inputRef}
              value={inputValue ? applyMask(inputValue) : ""}
              onInput={(e) => setInputValue(e.target.value)}
              className="input-number"
              placeholder="(__)-__-__-__"
              readOnly
            />
            <div className="edit-pencil-container">
              <img
                ref={pencilImgRef}
                className="edit-pencil-img"
                loading="lazy"
                src={require("./img-login/edit-pencil.svg").default}
                alt="pencil image"
              />
            </div>
            <p ref={errorNumberRef} className="error-number">
              Incorrect number
            </p>
          </div>

          <div className="keypad">
            {Array.from({ length: 9 }, (_, i) => i + 1).map((num) => (
              <button
                className="btn-number"
                key={num}
                onClick={() => handleKeyPress(num.toString())}
              >
                {num}
              </button>
            ))}
            <button
              className="btn-number last-row"
              onClick={() => handleKeyPress("0")}
            >
              0
            </button>
            <button className="clear-btn" onClick={handleClear}>
              <img src={btnCancel} alt="cancel button" />
            </button>
          </div>

          <button className="btn-keypad-send" onClick={handleCheckNumber}>
            Continue
          </button>
          <a
            className="login-form__my-account"
            onClick={() => navigate(RoutesToPages.account)}
          >
            My account
          </a>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
